module.exports = __webpack_public_path__ + "static/media/edwinVermulst.e3c9cf9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/authorSpotlight/edwinVermulst.jpg
// module id = 1563
// module chunks = 1